import React from 'react';
import { bonuses } from '../data/bonuses';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-4" data-id="element-16" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="22ellmti09lkx">
        <div className="mb-2 text-center" data-id="element-18" data-mp="22diuckgrth4h">
          <h2 className="mb-1 font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-19" data-mp="1ydi3g0chjdgj">
            🎁 5 Premium Bonuses Included
          </h2>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-20" data-mp="1am2zk3528o36">
            Your access also includes five complementary professional resources designed to help you
            manage rotations, evaluate players, communicate more effectively, organize match day, and
            run better tryouts.
          </p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="qywzu5ghmslp">
          {bonuses.map(bonus => <a key={bonus.title} href={OFFER_ANCHOR} className="rounded-lg border border-brand-gold/70 bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-blue" data-id="element-22" data-mp="my3b59v819rr">
              <h3 className="font-head text-[14px] font-bold leading-tight text-brand-navy sm:text-lg" data-id="element-23" data-mp="2jhwbq8x4xsc9">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-24" data-mp="2ofo75cwznwl7">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}